export enum SignupErrorMessages {
  ReCaptchaThresholdNotMet = 'ReCaptcha threshold not met',
  ReCaptchaBrowserError = 'ReCaptcha browser error',
}
